import { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import GridPage from "../components/GridPage";
import { excelExportReferralTrackingHeaders, ReferralTrackingHeaders } from "../components/HeaderAttribute";
import { BindPostAPI, IUDAPI } from "../services/APIConnection";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import { useUserCapability } from "../components/ConstantReducerProvider";
import Loader from "../ReusableComponents/Loader";
import * as XLSX from "sheetjs-style";

const ReferralTracking = () => {
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;
  const location = useLocation();
  const [referralTrackingDatas, setReferralTrackingDatas] = useState([]);
  const [date, setDate] = useState("");
  const [beneficiaryNameEn, setBeneficiaryNameEn] = useState("");
  const [beneficiaryNameTa, setBeneficiaryNameTa] = useState("");
  const [beneficiaryNameHi, setBeneficiaryNameHi] = useState("");
  const [beneficiaryNameMr, setBeneficiaryNameMr] = useState("");
  const [beneficiaryNameGu, setBeneficiaryNameGu] = useState("");
  const [beneficiaryNameKn, setBeneficiaryNameKn] = useState("");
  const [beneficiaryNameMl, setBeneficiaryNameMl] = useState("");
  const [beneficiaryNameTe, setBeneficiaryNameTe] = useState("");
  const [beneficiaryNameBn, setBeneficiaryNameBn] = useState("");
  const [beneficiaryNameOr, setBeneficiaryNameOr] = useState("");
  const [referralService, setReferralService] = useState("");
  const [rowIndexData, setRowIndexData] = useState("");
  const [referralTrackingId, setReferralTrackingId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [clearReferralTrackingValues, setClearReferralTrackingValues] =
    useState(false);

  const [referredTo, setReferredTo] = useState("");
  const [serviceReceived, setServiceReceived] = useState("");
  const [serviceReceivedFrror, setServiceReceivedError] = useState("");
  const [followUpBy, setFollowUpBy] = useState("");
  const [dateFollowedUp, setDateFollowedUp] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const handleClearReferralTrackingValues = (data) => {
    data && setClearReferralTrackingValues(false);
  };

  const cancel = () => {
    setIsLoading(false);
    setClearReferralTrackingValues(true);
    setRowIndexData("");
    setServiceReceivedError("");
    setDate("");
    setFollowUpBy("");
    setDateFollowedUp(undefined);
    setServiceReceived("");
    setReferralTrackingId("");
    setReferredTo("");
    setMobileNumber("");
    setReferralService("");
    referralTrackingData(userProfileDatas);
  };

  const referralTrackingData = async (userProfileDatas) => {
    if (userProfileDatas && userProfileDatas[0]) {
      setIsLoading(true);
      const Binddata = {
        mstOrganizationStructureId: userProfileDatas[0].MstOrganizationId,
        mstBranchId: userProfileDatas[0].MstLocationId,
        mstSdpId: userProfileDatas[0].MstSDPId
          ? userProfileDatas[0].MstSDPId
          : 0,
        mstUserId: userProfileDatas[0].MstUserId,
        mstRoleId: userProfileDatas[0].MstRoleId,
      };
      const response = await BindPostAPI(
        [Binddata],
        "IECAPI/BindReferralTracking"
      );

      const filteredData = response.data.Table;
      setReferralTrackingDatas(filteredData);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    referralTrackingData(userProfileDatas);
  }, [userProfileDatas]);
  const handleNotificationData = (updatedData) => {
    updatedData.forEach((item) => {
      setRowIndexData(item.RowIndex);
      setDate(item.Date);
      setBeneficiaryNameEn(item.BeneficiaryNameEn);
      setBeneficiaryNameTa(item.BeneficiaryNameTa);
      setBeneficiaryNameHi(item.BeneficiaryNameHi);
      setBeneficiaryNameMr(item.BeneficiaryNameMr);
      setBeneficiaryNameGu(item.BeneficiaryNameGu);
      setBeneficiaryNameKn(item.BeneficiaryNameKn);
      setBeneficiaryNameMl(item.BeneficiaryNameMl);
      setBeneficiaryNameTe(item.BeneficiaryNameTe);
      setBeneficiaryNameBn(item.BeneficiaryNameBn);
      setBeneficiaryNameOr(item.BeneficiaryNameOr);
      setReferralService(item.ReferralService);
      setReferredTo(item.ReferredTo);
      setServiceReceived(item.ServiceReceived);
      setFollowUpBy(item.FollowUpBy);
      setDateFollowedUp(item.DateFollowedUp);
      setMobileNumber(item.MobileNo);
      setReferralTrackingId(item.TxnReferralTrackingId);
    });
  };
  const HandleSubmit = async (rowIndex) => {

    const errorServiceReceived = serviceReceived
      ? ""
      : "Select service received";
    const errorFollowedupBy = dateFollowedUp ? "" : "Select date followedUp";
    setServiceReceivedError(errorServiceReceived);
    if (errorServiceReceived !== "") {
      toast.error("Fill Service received and Date followed up", {
        duration: 1000,
        position: "top-center",
      });
      cancel()
      return;
    }
    if (errorFollowedupBy !== "") {
      toast.error("Select date followed up", {
        duration: 1000,
        position: "top-center",
      });
      cancel()
      return;
    }
    if (errorServiceReceived === "") {
      if (rowIndex === rowIndexData[0]) {
        setIsLoading(true)
        const data = {
          txnReferralTrackingId: referralTrackingId,
          date: date,
          beneficiaryNameEn: beneficiaryNameEn,
          beneficiaryNameTa: beneficiaryNameTa,
          beneficiaryNameHi: beneficiaryNameHi,
          beneficiaryNameMr: beneficiaryNameMr,
          beneficiaryNameGu: beneficiaryNameGu,
          beneficiaryNameKn: beneficiaryNameKn,
          beneficiaryNameMl: beneficiaryNameMl,
          beneficiaryNameTe: beneficiaryNameTe,
          beneficiaryNameBn: beneficiaryNameBn,
          beneficiaryNameOr: beneficiaryNameOr,
          mobileNo: mobileNumber,
          referralService: referralService,
          referredTo: referredTo,
          serviceReceived: serviceReceived,
          followUpBy: followUpBy,
          dateFollowedUp: dateFollowedUp ? dateFollowedUp : null,
          createdBy: sessionStorage.getItem("createdBy"),
          flag: 1,
        };

        const response = await IUDAPI([data], "IECAPI/IUDReferralTracking");

        if (response.data.Table[0].Result === "M") {

          toast.success("NextFollowUp data Insert successfully 👍", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
          referralTrackingData(userProfileDatas);
        } else {
          toast.error("NextFollowUp data Insert Failed 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else {
        toast.error(
          "NextFollowUp data Insert Failed 👎. Please Fill One Row only",
          {
            duration: 1000,
            position: "top-center",
          }
        );
        setTimeout(cancel, 1000);
      }
    }
  };
  useEffect(() => {
    if (location.pathname == "/referraltracking") {
      referralTrackingData(userProfileDatas);
    }
  }, [location]);

  // const handleExport = async () => {
  //   debugger

  //   // ✅ PASS ONLY STRING HEADERS (same as commodities)
  //   exportData(
  //     excelExportReferralTrackingHeaders.map((column) => column.title),
  //     referralTrackingDatas
  //   );

  // };

  const handleExport = async () => {
    debugger;
  
    const createdBy = sessionStorage.getItem("createdBy");
  
    try {
      const rows = referralTrackingDatas || [];
  
      if (rows.length === 0) {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "REFERRAL TRACKING",
            action: "EXCEL EXPORT",
            status: "FAILED",
            tableName: "txn_referral_tracking",
            description: "No data available to export",
          },
          "Log/IUDLog"
        );
  
        toast.error("No data available to export", {
          duration: 1000,
          position: "top-center",
        });
  
        return;
      } else {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "REFERRAL TRACKING",
            action: "EXCEL EXPORT",
            status: "SUCCESS",
            tableName: "txn_referral_tracking",
            description: `Referral Tracking Excel exported successfully. Total Records: ${rows.length}`,
          },
          "Log/IUDLog"
        );
      }
  
      exportData(
        excelExportReferralTrackingHeaders.map((column) => column.title),
        rows
      );
    } catch (error) {
      console.error("Referral Tracking Export Error:", error);
  
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "REFERRAL TRACKING",
          action: "EXCEL EXPORT",
          status: "FAILED",
          tableName: "txn_referral_tracking",
          description: error?.message || "Referral Tracking export failed",
        },
        "Log/IUDLog"
      );
  
      toast.error("Failed to export Excel", {
        duration: 1000,
        position: "top-center",
      });
    }
  };
  const exportData = (columns, rows) => {
    /* ================= TITLE ================= */
    const titleRow = [
      {
        v: "Referral Tracking",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    /* ================= HEADER ================= */
    const headerRow = columns.map((column) => ({
      v: column, // ✅ STRING ONLY
      s: {
        fill: { fgColor: { rgb: "2D2D6E" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" },
      },
    }));

    const spacingRow = [{ v: "" }];

    /* ================= DATA ROWS ================= */
    const dataRows = rows.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;
      const baseStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      return [
        { v: index + 1, s: baseStyle },
        { v: rowData.TxnReferralTrackingId || '- ', s: baseStyle },
        { v: rowData.FormattedDate || '- ', s: baseStyle },
        { v: rowData.ParticipantName_en || '- ', s: baseStyle },
        { v: rowData.MobileNo || '- ', s: baseStyle },
        { v: rowData.ReferredBy_en || '- ', s: baseStyle },
        { v: rowData.ReferredTo_en || '- ', s: baseStyle },
        { v: rowData.ServiceReceived || '- ', s: baseStyle },
        { v: rowData.FormattedFollowUpBy || '- ', s: baseStyle },
        { v: rowData.DateFollowedUp || '- ', s: baseStyle },
        { v: rowData.FullName_en || '- ', s: baseStyle },

      ];
    });

    /* ================= SHEET DATA ================= */
    const wsData = [
      titleRow,
      spacingRow,
      headerRow,
      ...dataRows,
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    /* ================= COLUMN WIDTHS ================= */
    ws["!cols"] = [
      { width: 5 },   // S.No
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 30 },

    ];

    /* ================= ROW HEIGHTS ================= */
    ws["!rows"] = [
      { hpt: 30 },
      { hpt: 15 },
      { hpt: 18 },
      ...Array(rows.length).fill({ hpt: 15 }),
    ];

    /* ================= BORDERS ================= */
    const applyStyles = (worksheet) => {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!worksheet[cellRef]) continue;

          worksheet[cellRef].s = {
            ...worksheet[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    /* ================= EXPORT ================= */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SDP Master");
    XLSX.writeFile(wb, "Referral Tracking.xlsx");

    toast.success("Excel exported successfully 👍", {
      duration: 1000,
      position: "top-center",
    });
  };


  return (
    <MainLayout pageName="3">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      <GridPage
        title="Referral Tracking"
        blockView={false}
        addView={true}
        tableHeight="h-72"
        xScroll="overflow-x-auto max-md:w-fit w-full"
        tableScroll="relative z-0 flex flex-col md:block hidden border text-sm text-left text-gray-500 w-full md:min-w-fit"
        header={ReferralTrackingHeaders}
        records={referralTrackingDatas}
        onNotificationDatas={handleNotificationData}
        onNotificationClear={clearReferralTrackingValues}
        onNotificationClearFalse={handleClearReferralTrackingValues}
        onNotificationSave={HandleSubmit}
        handleExportBtn={true}
        handleExport={handleExport}
      />
    </MainLayout>
  );
};

export default ReferralTracking;
